<template>
    <div class="main-background">
        <div class="user-page-avatar-main-container">
            <div v-if="!customerImg" class="user-page-avatar-null-container">
                <question-icon class="user-page-avatar-null-icon"/>
            </div>
            <img v-else :src="baseApiUrl + customerImg" alt="Avatar" class="user-page-avatar-image">
            <!-- <div class="user-page-avatar-downloader-container">
                <input type="file" @change="handleFileChange" class="user-page-avatar-downloader">
                <camera-icon class="user-page-avatar-downloader-icon"/>
            </div> -->
        </div>
        <div class="user-page-main-information-inputs-container">
            <div class="user-page-main-information-input-name-container">
                <user-icon class="user-page-main-information-input-name-icon"/>
                <input type="text" class="user-page-main-information-input" v-model="customerName">
            </div>
        </div>
        <div class="user-page-main-information-checkbox-container">
            <div>
            <div class="main-time-zone-container" @click="isShowTimeZoneList = !isShowTimeZoneList">
                <clock-icon class="main-time-zone-icon"/>
                <p class="used-time-zone-element">{{ usedTimeZone || 'Виберіть часову зону' }}</p>
                <chevron-down-icon class="time-zone-chevron-icon" :style="[isShowTimeZoneList && {transform: 'rotate(180deg)'}]"/>
                <transition name="fade">
                    <ul v-if="isShowTimeZoneList" class="time-zone-list">
                        <vue-perfect-scrollbar class="time-zone-scrollvar">
                            <li
                                v-for="time in timezones" 
                                :key="time"
                                class="time-zone-list-item"
                                @click.stop="setChangeTimeZone(time)"
                            >
                            {{ time }}
                            </li>
                        </vue-perfect-scrollbar>
                    </ul>
                </transition>
            </div>
            <p class="main-time-zone-info">Часова зона за якою будуть надходити нагадування</p>
            </div>
            <div class="user-page-main-information-checkbox">
                <p class="user-page-main-information-checkbox-text">Сповіщення про нові проєкти</p>
            <div class="checkbox-apple">
            <input class="yep" id="check-apple" type="checkbox" v-model="reminderNew">
            <label for="check-apple"></label>
            </div>
            </div>
            <div class="user-page-main-information-checkbox">
                <p class="user-page-main-information-checkbox-text">Сповіщення про вибрані проєкти</p>
            <div class="checkbox-apple">
            <input class="yep" id="check-apple-second" type="checkbox" v-model="reminderFavorite">
            <label for="check-apple-second"></label>
            </div>
            </div>
        </div>
        <div class="user-page-drop-navigator-container" @click="copyText">
            <p class="user-page-drop-navigator-title">
            <ticket-icon class="user-page-drop-navigator-icon-ticket"/>
            Поділитись Drop Navigator 
            <copy-icon class="user-page-drop-navigator-icon-copy"/>
            </p>
            <p class="user-page-drop-navigator-info">{{ customerRefererLink }}</p>
        </div>
        <button @click="saveChangedData" class="user-page-save-button">
            Зберегти
        </button>
             <div :class="`tooltip ${isCopiedText ? 'show' : ''}`">
                Посилання скопійовано
            </div>
              <div :class="`tooltip-up ${isSavedChanges ? 'show' : ''}`">
                Збережено
            </div>
    </div>
</template>

<script>

import { 
    // CameraIcon, 
    UserIcon, 
    CopyIcon,
    ClockIcon,
    ChevronDownIcon
 } from 'vue-feather-icons'
import { mapMutations } from "vuex";
import QuestionIcon from '../icons/QuestionIcon.vue';
import TicketIcon from '../icons/TicketIcon.vue';
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
    name: "user-page",
    components: {
        QuestionIcon,
        // CameraIcon,
        UserIcon,
        CopyIcon,
        TicketIcon,
        ClockIcon,
        ChevronDownIcon,
        VuePerfectScrollbar
    },
    props: {

    },
    data() {
        return {
            customerImg: '',
            isCopiedText: false,
            isSavedChanges: false,
            isShowTimeZoneList: false,
            reminderNew: false,
            reminderFavorite: false,
            usedTimeZone: 'Europe/Kyiv (GMT+3)',
            customerName: '',
            baseApiUrl: 'https://crypto-drops-open.boto.kyiv.ua'
        }
    },
    mounted() {
        window.scrollTo(0, 0);
        this.customerName = this.currentCustomer?.name
        this.customerImg = this.currentCustomer?.img
        this.usedTimeZone = this.currentCustomer?.timezone
        this.reminderNew = this.currentCustomer?.reminder_new
        this.reminderFavorite = this.currentCustomer?.reminder_favorite
    },
    computed: {
       openedProduct() {
         return this.$store.getters.openedProduct
       },
       currentCustomer() {
        return this.$store.getters.currentCustomer
       },
       customerRefererLink() {
        return this.$store.getters.customerRefererLink
       },
       timezones() {
        return this.$store.getters.timezones
       }
    },
    methods: {
        ...mapMutations(['addToWishList']),
    handleFileChange(event) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            this.customerImg = event.target.result;
        };
        reader.readAsDataURL(file);
        console.log(this.customerImg)
        },
        copyText() {
        navigator.clipboard.writeText(this.customerRefererLink) 
        this.isCopiedText = true;
        setTimeout(() => {
            this.isCopiedText = false;
        }, 2000);
    },
    setChangeTimeZone(value) {
        this.usedTimeZone = value
        this.isShowTimeZoneList = false
    },
    saveChangedData() {
        this.setChangeCustomerName()
        this.isSavedChanges = true;
        setTimeout(() => {
            this.isSavedChanges = false;
        }, 2000);
    },
    setChangeCustomerName() {
        let data = {
            id: this.currentCustomer.id,
            name: this.customerName,
            reminder_new: this.reminderNew,
            reminder_favorite: this.reminderFavorite,
            timezone: this.usedTimeZone.split(' ')[0]
        }
        this.$store.dispatch('setEditCustomerName', data)
    }

    },
    watch: {

    }
}
</script>

<style scoped>

.main-background {
    background: #121212;
}

.user-page-avatar-main-container {
    width: 100%;
    padding: 32px;
    position: relative;
}

.user-page-avatar-null-container {
    display: block;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: #A0A0A0;
    margin: 0 auto;
}

.user-page-avatar-downloader-container {
    position: absolute;
    bottom: 15px;
    left: 52%;
    width: 40px;
    height: 40px;
    overflow: hidden;
    background: #1D1D1D;
    border-radius: 50%;
}

.user-page-avatar-downloader {
    position: relative;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 10;
}

.user-page-avatar-downloader-icon {
    color: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.user-page-avatar-image {
    display: block;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    margin: 0 auto; 
    object-fit: cover;
    object-position: center;
}

.user-page-avatar-null-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    color: #fff;
}

.user-page-main-information-inputs-container {
    padding: 0px 16px;

}

.user-page-main-information-input-name-container {
    position: relative;
}

.user-page-main-information-input-name-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 12px;
    color: #FFF;
    width: 24px;
    height: 24px;
}

.user-page-main-information-input {
    border-radius: 8px;
    background: #1D1D1D;
    padding: 12px 48px;
    color: #FFF;
    font-family: "Comfortaa", sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
    outline: none;
    border: none;
}

.user-page-main-information-checkbox-container {
    padding: 40px 16px;
    display: flex;
    flex-direction: column;
    gap: 33px;
}

.user-page-main-information-checkbox {
    display: flex;
    justify-content: space-between;
    gap: 10px;
}

.user-page-main-information-checkbox-text {
    color: #FFF;
    font-family: "Comfortaa", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
}

/* /////////////////// */

.checkbox-apple {
  position: relative;
  width: 50px;
  height: 25px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.checkbox-apple label {
  position: absolute;
  top: 0;
  left: 0;
  width: 50px;
  height: 25px;
  border-radius: 50px;
  background: linear-gradient(to bottom, #b3b3b3, #e6e6e6);
  cursor: pointer;
  transition: all 0.3s ease;
}

.checkbox-apple label:after {
  content: '';
  position: absolute;
  top: 1px;
  left: 1px;
  width: 23px;
  height: 23px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.checkbox-apple input[type="checkbox"]:checked + label {
  background: linear-gradient(to bottom, #4cd964, #5de24e);
}

.checkbox-apple input[type="checkbox"]:checked + label:after {
  transform: translateX(25px);
}

.checkbox-apple label:hover {
  background: linear-gradient(to bottom, #b3b3b3, #e6e6e6);
}

.checkbox-apple label:hover:after {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.yep {
  position: absolute;
  top: 0;
  left: 0;
  width: 50px;
  height: 25px;
}

.user-page-drop-navigator-container {
    border-radius: 8px;
    border: 1px solid #1D1D1D;
    display: block;
    width: 90%;
    margin: 0 auto;
    padding: 16px;

}

.user-page-drop-navigator-title {
    color: #FFF;
    font-family: "Comfortaa", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
}

.user-page-drop-navigator-icon-ticket {
    margin-right: 12px;
    vertical-align: -6px;
}

.user-page-drop-navigator-icon-copy {
    margin-left: 12px;
    color: #A0A0A0;
    width: 24px;
    height: 24px;
    vertical-align: -6px;
}

.user-page-drop-navigator-info {
    color: #A0A0A0;
    font-family: "Comfortaa", sans-serif;
    font-size: 10px;
    font-weight: 400;
    line-height: 24px; 
    margin-top: 12px;
    text-align: center;
}

.user-page-save-button {
    border-radius: 8px;
    display: block;
    width: 90%;
    margin: 28px auto 0 auto;
    background: #1E7CE9;
    border: none;
    padding: 12px;
    color: #FFF;
    text-align: center;
    font-family: "Comfortaa", sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
}

.main-time-zone-container {
    position: relative;
    width: 100%;
    border: 1px solid #ffffff21;
    border-radius: 8px;
    background: #1D1D1D;
    padding: 15px 50px;
}

.main-time-zone-icon {
    position: absolute;
    color: #fff;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
}

.time-zone-chevron-icon {
    position: absolute;
    color: #fff;
    right: 10px;
    top: 15px;
    transition: all .5s ease;
}

.used-time-zone-element {
  color: #FFF;
    font-family: "Comfortaa", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: normal;  
}

.time-zone-list {
    position: absolute;
    height: auto;
    max-height: 185px;
    width: 100%;
    border-radius: 5px;
    z-index: 1;
    list-style: none;
    padding: 10px 5px 10px 10px;
    top: 50px;
    left: 0px;
    overflow: hidden !important;
    background: #1D1D1D;
    border: 1px solid #ffffff21;
}

.time-zone-list-item {
    color: #FFF;
    font-family: "Comfortaa", sans-serif;
    font-size: 16px;
    font-weight: 500;
    padding: 10px 5px;
    line-height: normal;
    cursor: pointer;
    border-radius: 5px;
    transition: all .5s ease;
}

.time-zone-list-item:hover {
    background: #8e8d8d;
}

.main-time-zone-info {
    color: #FFF;
    font-family: "Comfortaa", sans-serif;
    font-size: 10px;
    font-weight: 500;
    line-height: normal;
    margin-top: 5px;
}

.tooltip {
    position: fixed;
    background-color: #545454;
    color: #fff;
    border: 1px solid #ccc;
    font-family: "Comfortaa", sans-serif;
    padding: 0 10px;
    border-radius: 5px;
    bottom: 10px;
    padding: 4px;
    width: 60%;
    left: 50%;
    text-align: center;
    transition: all .5s ease;
    transform: translate(-50%, 200%);
}

.tooltip-up {
    position: fixed;
    background-color: #545454;
    color: #fff;
    border: 1px solid #ccc;
    font-family: "Comfortaa", sans-serif;
    padding: 0 10px;
    border-radius: 5px;
    top: 10px;
    padding: 4px;
    width: 40%;
    left: 50%;
    text-align: center;
    transition: all .5s ease;
    transform: translate(-50%, -200%);
}

.tooltip-up.show {
    transform: translate(-50%, 0%);
}

.tooltip.show {
    transform: translate(-50%, 0%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  
}

.time-zone-scrollvar {
    background: #1D1D1D;
    position: relative;
    margin: auto;
    width: 100%;
    max-height: 160px;
}

</style>